import { themedUseStyletron } from '../../theme/customTheme'
import { getMeasurmentColor } from '../../utils/colorUtils'



function  useGetMeasurmentColor(dimension?: string, schema?: string | undefined): [string] {
  const[css,theme] = themedUseStyletron();
  const isNormalPercentSensor = (schema && dimension) && (schema === 'AutomationApps.Devices.Sensors.SensorAnalog' && dimension === '%');
  if ( isNormalPercentSensor)
    return [getMeasurmentColor('default',theme)];


  return [getMeasurmentColor(dimension || 'default', theme)]
}

export default useGetMeasurmentColor